import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/FirebaseAuthContext';

interface OnboardingRouteProps {
  children: React.ReactNode;
}

const OnboardingRoute: React.FC<OnboardingRouteProps> = ({ children }) => {
  const { user, loading, userPreferences } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Only redirect to dashboard if user has completed onboarding and is trying to access onboarding steps (not confirmation)
  const path = window.location.pathname;
  if (userPreferences?.hasCompletedOnboarding && path.startsWith('/onboarding') && path !== '/onboarding/complete') {
    return <Navigate to="/dashboard" />;
  }

  return <>{children}</>;
};

export default OnboardingRoute; 